import { Component, OnInit } from '@angular/core';
import { OidcAuthService } from '@app/core/services/oidc-auth.service';
import { Router } from '@angular/router';
import { FeatureService } from '@app/core/services/feature.service';
import { SettingsService } from "@app/core/services/settings.service";
import { EmployeeService } from '../services/employee.service';
import { ModuleConfigurationService } from '../services/module-configuration/module-configuration.service';
import { StylingColoursService } from '@app/modules/site-settings-styling/components/styling-colours/services/styling-colours.service';
import { CompanyLogosService } from '@app/modules/site-settings-styling/components/company-logos/services/company-logos.service';

@Component({
    selector: 'app-auth-callback',
    templateUrl: './auth-callback.component.html',
    styleUrls: ['./auth-callback.component.scss']
})
export class AuthCallbackComponent implements OnInit {

    error: boolean;

    constructor(
      private authService: OidcAuthService,
      private router: Router,
      private featureService: FeatureService,
      private moduleConfigurationService: ModuleConfigurationService,
      private settingsService: SettingsService,
      private employeeService: EmployeeService,
      private stylingColoursService: StylingColoursService,
      private companyLogosService: CompanyLogosService
    ) {
    }

    async ngOnInit() {
        await this.authService.completeAuthentication()
        .then(
          returnUrl => {
            this.companyLogosService.syncActiveCompanyLogo(
              () => {
                this.stylingColoursService.syncActiveStylingColour(
                  () => {
                    this.employeeService.syncCurrentUserDetails(
                      () => {
                        this.moduleConfigurationService.syncCurrentUserModules(
                          () => {
                            this.featureService.syncCurrentUserFeatures(
                              () => {
                                this.settingsService.syncSiteSettings(
                                  () => {
                                    this.router.navigateByUrl('Homepage');
                                  }
                                )
                              }
                            )
                          }
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        )
        .catch(
            (err) => {
                this.router.navigate(['Homepage']);
            }
        );
    }
}
